import booleanPointInPolygon from '@turf/boolean-point-in-polygon';
import buffer from '@turf/buffer';
import { point } from '@turf/helpers';
export function bufferedBoundary(boundary, meters) {
    const result = buffer(boundary, meters, { units: 'meters' });
    if (!result || result.type !== 'FeatureCollection') {
        throw new Error('Unable to buffer property boundary');
    }
    return result;
}
export function inBoundary(position, boundary, bufferMeters = 0) {
    const fence = bufferMeters > 0 && boundary.type === 'FeatureCollection'
        ? bufferedBoundary(boundary, bufferMeters)
        : boundary;
    const candidate = point([position.longitude, position.latitude]);
    if (fence.type === 'FeatureCollection') {
        return fence.features.some((feature) => booleanPointInPolygon(candidate, feature));
    }
    return booleanPointInPolygon(candidate, fence);
}
export class GeofenceHysteresis {
    consecutiveFixes;
    state;
    candidate;
    count = 0;
    constructor(consecutiveFixes, initialState) {
        this.consecutiveFixes = consecutiveFixes;
        if (!Number.isInteger(consecutiveFixes) || consecutiveFixes < 1)
            throw new Error('consecutiveFixes must be positive');
        this.state = initialState;
    }
    observe(inside) {
        if (this.state === undefined) {
            if (this.candidate === inside)
                this.count += 1;
            else {
                this.candidate = inside;
                this.count = 1;
            }
            if (this.count >= this.consecutiveFixes) {
                this.state = inside;
                this.candidate = undefined;
                this.count = 0;
                return { inside: this.state, changed: true };
            }
            return { inside: undefined, changed: false };
        }
        if (inside === this.state) {
            this.candidate = undefined;
            this.count = 0;
            return { inside: this.state, changed: false };
        }
        if (this.candidate === inside)
            this.count += 1;
        else {
            this.candidate = inside;
            this.count = 1;
        }
        if (this.count >= this.consecutiveFixes) {
            this.state = inside;
            this.candidate = undefined;
            this.count = 0;
            return { inside: this.state, changed: true };
        }
        return { inside: this.state, changed: false };
    }
}
